import { render, staticRenderFns } from "./CertificateSettings.vue?vue&type=template&id=6e4efbae&scoped=true&"
import script from "./CertificateSettings.vue?vue&type=script&lang=js&"
export * from "./CertificateSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4efbae",
  null
  
)

export default component.exports